import React, { Fragment } from 'react';
import _get from 'lodash/get';
import _set from 'lodash/set';
import { getNormalErrors } from 'helpers';

export function handleChange(key, value, {type = 'text', required = false} = {}) {

  function isTypeNumber() {
    return type === 'number';
  }

  function validateValue(value) {
    let dots = 0;
    return !isTypeNumber() ? value : value
      .replace(/[^\d|\.|-]/, '')
      .replace(/\./g, function() { return dots++ > 0 ? '' : '.'; })
      .replace(/\-/g, function(match, str) { return str === 0 ? '-' : '' });
  }

  let state = JSON.parse(JSON.stringify(this.state));
  let errors = {};

  _set(state, key, validateValue(value));

  if (_get(this.state, key, '') === _get(state, key, '')) {
    return false;
  }

  errors[key] = (value && isTypeNumber() ? !isNaN(parseFloat(value)) : true) ? '' : required ? 'required' : ''

  this.setState({
    ...state,
    errors: {
      ...this.state.errors,
      ...errors
    }
  })
}

export function getError(error, cb) {
  let composedErrors = getNormalErrors(error);
  let errData = composedErrors.errors;
  let errMsg = composedErrors.errors;
  let stateErr = {
    errors: {},
    error: ''
  };

  errMsg && (stateErr.error = errMsg);
  Object.keys(errData).length && (stateErr.errors = errData);

  if (!Object.keys(stateErr).length) {
    return false;
  }

  if (Object.keys(stateErr.errors || {}).length && !stateErr.error) {
    stateErr.error = 'Check all fields filled correctly';
  }

  this.setState({...stateErr}, cb);

  return stateErr;
}

export function renderError() {
  return this.state.error ?
    <div className='m-v-1 error'>{this.state.error}</div>
  : ''
}



// WEBPACK FOOTER //
// ./app/components/Base/RenderField/index.js